"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankListRequest = void 0;
var RankListRequest = /** @class */ (function () {
    function RankListRequest() {
    }
    return RankListRequest;
}());
exports.RankListRequest = RankListRequest;
//# sourceMappingURL=rankList.request.js.map